






















































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';

@Component({
  name: 'AddingLodgers',
  props: {
    lodgersList: {
      type: Array,
      default: () => [],
    },
    apartmentId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showDeletingLodgersModal: false,
      deletingLodger: {},
      deletedLodger: false,
    };
  },
  computed: {
    ...mapGetters('profile', ['lodgersBlockTexts']),
  },
  methods: {
    ...mapActions('profile', ['deleteLodgerFromApart']),
    openDeletingLodgersModal(lodger) {
      this.deletingLodger = lodger;
      this.showDeletingLodgersModal = true;
    },
    closeDeletingLodgersModal() {
      this.showDeletingLodgersModal = false;
      this.deletingLodger = {
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        description: '',
        per_object_permissions: [],
      };
      this.deletedLodger = false;
    },
    deleteLodger() {
      this.deleteLodgerFromApart({id: this.apartmentId, lodger: this.deletingLodger.id})
          .then((response) => {
            this.deletedLodger = true;
          })
          .catch((error) => {
            console.log(error, 'deleting lodger');
          });
      console.log('delete');
    },
    stringWithName(str) {
      return str.replace('%(name)s',
          `${this.deletingLodger.first_name} ${this.deletingLodger.last_name}`);
    },
  },
})
export default class AddingLodgers extends Vue {}
